import { render, staticRenderFns } from "./EmailRecipientCollector.vue?vue&type=template&id=98b7652c"
import script from "./EmailRecipientCollector.vue?vue&type=script&lang=js"
export * from "./EmailRecipientCollector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports